import { connect } from "react-redux";
import { AppState } from "../../../store/AppState";
import OrganizationUtils from "../../../utils/organization";
import InvitationsCard, {
  InvitationsCardProps as _InvitationsCardProps
} from "./invitations-card-view";

import {
  PickReduxDispatchProps,
  PickReduxStateProps
} from "../../../util/typeUtil";
import { listOrganizationsOrganizationGroupInvitations } from "../../../actions";
import InProgressUtils from "../../../utils/in-progress";
import { ActionSender } from "../../../model/ActionSender";
import { addSenderArgument } from "../../../actions/actionHelpers";
import {OrganizationGroupInvitationWithExpiredStatus, populateExpiredStatus} from "../../../utils/invitation";

export interface InvitationsCardProps
  extends Pick<_InvitationsCardProps, "moreAction"> {}

// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<
  _InvitationsCardProps,
  InvitationsCardProps
>;

// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _InvitationsCardProps,
  InvitationsCardProps
>;

const sender: ActionSender = { key: "invitationsCard" };

function mapStateToProps(state: AppState): ReduxStateProps {
  const invitations = OrganizationUtils.selectOrganizationInvitations(state)?.map(populateExpiredStatus) as OrganizationGroupInvitationWithExpiredStatus[];
  const pendingCount = !!invitations
    ? invitations.filter((i: OrganizationGroupInvitationWithExpiredStatus) => {
        return i.invitationState === "deliveryRequested";
      }).length
    : 0;
  const unsentCount = !!invitations
    ? invitations.filter((i: OrganizationGroupInvitationWithExpiredStatus) => {
        return i.invitationState === "created";
      }).length
    : 0;
  const declinedCount = !!invitations
    ? invitations.filter((i: OrganizationGroupInvitationWithExpiredStatus) => {
        return i.invitationState === "declined";
      }).length
    : 0;
  const revokedCount = !!invitations
    ? invitations.filter((i: OrganizationGroupInvitationWithExpiredStatus) => {
        return i.invitationState === "revoked";
      }).length
    : 0;
  const acceptedCount = !!invitations
    ? invitations.filter((i: OrganizationGroupInvitationWithExpiredStatus) => {
        return i.invitationState === "accepted";
      }).length
    : 0;
  const updatedCount = !!invitations
      ? invitations.filter((i: OrganizationGroupInvitationWithExpiredStatus) => {
        return i.invitationState === "updated";
      }).length
      : 0;
  const expiredCount = !!invitations
      ? invitations.filter((i: OrganizationGroupInvitationWithExpiredStatus) => {
        return i.invitationState === "expired";
      }).length
      : 0;
  return {
    pendingCount,
    unsentCount,
    declinedCount,
    revokedCount,
    acceptedCount,
    updatedCount,
    expiredCount,
    invitations: invitations,
    isReady: InProgressUtils.selectNotInProgress(sender.key, state)
  };
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
    InProgressUtils.compareInProgressStates(next, prev) &&
    OrganizationUtils.compareOrganizationInvitationsStates(next, prev)
  );
}

const dispatchActions: ReduxDispatchProps = {
  onLoadInvitations: addSenderArgument(
    sender,
    listOrganizationsOrganizationGroupInvitations
  )
};

export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  InvitationsCardProps,
  AppState
>(mapStateToProps, dispatchActions, null, {
  areStatesEqual
})(InvitationsCard);
